module.exports = __webpack_public_path__ + "img/swap-banner-xpr-2.ae3a586.gif";